import { FieldValue, fieldControlClass, fieldDescribedBy } from "./FieldValue";
import { FileUploadFieldProps } from "./FileUploadField.types";

/** File upload editable field. */
export function FileUploadField({
  label,
  name,
  currentFileName,
  onChange,
  disabled,
  accept,
  error,
  className,
  helpText,
}: FileUploadFieldProps) {
  return (
    <FieldValue label={label} htmlFor={name} helpText={helpText} error={error} className={className}>
      <input
        id={name}
        aria-describedby={fieldDescribedBy(name, helpText, error)}
        aria-invalid={error ? true : undefined}
        name={name}
        type="file"
        className={fieldControlClass("form-control", error)}
        accept={accept}
        onChange={(event) => onChange(event.target.files?.[0] ?? null)}
        disabled={disabled}
      />
      {currentFileName && (
        <div className="form-text">Current file: {currentFileName}</div>
      )}
    </FieldValue>
  );
}
